<template>
  <div class="list_div" style="overflow-y: auto">
    <!--导航面包屑-->
<!--    <page-header :className="'header_breadcrumb_left'"></page-header>-->

  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="我的任务" name="myTask">
      <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;">
          <el-form :inline="true" :model="filters" :size="size">
            <el-form-item>
              <el-input v-model="filters.keywords" placeholder="输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
              <kt-button icon="fa fa-search" :label="$t('action.search')" type="primary" @click="findMyTask"/>
            </el-form-item>
            <el-form-item>
              <kt-button icon="fa fa-refresh" :label="$t('action.reset')" type="warning" @click="resetMyTask"/>
            </el-form-item>
          </el-form>
        </div>

        <!--表格内容栏-->
        <el-table :data="tableData1" stripe size="mini" style="width: 100%;" class="init-table"
                  v-loading="loading" :element-loading-text="$t('action.loading')">
          <el-table-column prop="type" header-align="center" align="center" label="任务类型">
          </el-table-column>
          <el-table-column prop="title" header-align="center" align="center" label="任务标题">
          </el-table-column>
          <el-table-column prop="createTime" header-align="center" align="center" label="创建时间">
          </el-table-column>
          <el-table-column prop="createUser" header-align="center" align="center" label="创建人">
          </el-table-column>
          <el-table-column prop="status" header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.statusColor" disable-transitions>{{scope.row.status}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center" :label="$t('action.operation')">
            <template slot-scope="scope">
              <el-dropdown trigger="click" size="small" split-button type="primary" plain>
                <span class="el-dropdown-link">操作</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-view" @click.native="handleView(scope.row)" :label="$t('action.edit')"
                                    perms="sys:taskDeal">查看
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-edit" @click.native="handleEdit(scope.row)">处理</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-delete" @click.native="handleDelete(scope.row)"
                                    :label="$t('action.delete')" perms="sys:taskDeal:delete">删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>

    <el-tab-pane label="已处理任务" name="solvedTask">
      <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;">
          <el-form :inline="true" :model="filters" :size="size">
            <el-form-item>
              <el-input v-model="filters.keywords" placeholder="关键字查询"></el-input>
            </el-form-item>
            <el-form-item>
              <kt-button :label="$t('action.search')" type="primary" @click="findSolvedTask()"/>
            </el-form-item>
            <el-form-item>
              <kt-button icon="fa fa-refresh" :label="$t('action.reset')" type="warning" @click="resetSolvedTask"/>
            </el-form-item>
          </el-form>
        </div>
        <!--表格内容栏-->
        <el-table :data="tableData2" stripe size="mini" style="width: 100%;" class="init-table"
                  v-loading="loading" :element-loading-text="$t('action.loading')">
          <el-table-column prop="type" header-align="center" align="center" label="任务类型">
          </el-table-column>
          <el-table-column prop="title" header-align="center" align="center" label="任务标题">
          </el-table-column>
          <el-table-column prop="createTime" header-align="center" align="center" label="创建时间">
          </el-table-column>
          <el-table-column prop="createUser" header-align="center" align="center" label="创建人">
          </el-table-column>
          <el-table-column prop="status" header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.statusColor" disable-transitions>{{scope.row.status}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center" min-width="50%" :label="$t('action.operation')">
            <template slot-scope="scope">
              <el-button icon="el-icon-view" size="mini" circle :title="'查看'" perms="sys:sysTaskDeal"
                         @click="handleView(scope.row)"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>

  import KtButton from "../Core/KtButton"
  import TableTreeColumn from '../Core/TableTreeColumn.vue'
  import PopupTreeInput from "../../components/PopupTreeInput"
  import FaIconTooltip from "../../components/FaIconTooltip"
  import {format} from "../../utils/datetime"

  export default {
    components: {
      PopupTreeInput,
      KtButton,
      TableTreeColumn,
      FaIconTooltip
    },
    data() {
      return {
        activeName: "myTask",
        size: 'small',
        loading: false,
        filters: {
          keywords: '',
        },
        columns: [],
        filterColumns: [],
        tableData1: [],
        tableData2: [],
        pageRequest: {pageNum: 1, pageSize: 10},
        editDialogVisible: false, // 新增编辑界面是否显示
        viewDialogVisible: false, // 查看界面是否显示
        dataForm: {},
        dataRule: {
          name: [
            {required: true, message: '请输入关键字', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      // 获取分页数据
      findMyTask: function () {
        this.loading = true;
        this.pageRequest.columnFilters = Object.assign({}, this.filters);
        this.$api.sysTaskDeal.myTasks(this.pageRequest).then((res) => {
          if (res.code === 200) {
            this.tableData1 = res.data.list
            this.loading = false
          }
        })
      },
      //重置查询选项
      resetMyTask: function () {
        this.filters = {
          keywords: ''
        };
        this.$forceUpdate();  // 强制更新
        this.findMyTask(null);
      },

      findSolvedTask: function () {
        this.loading = true;
        this.pageRequest.columnFilters = Object.assign({}, this.filters);
        this.$api.sysTaskDeal.solvedTasks(this.pageRequest).then((res) => {
          if (res.code === 200) {
            this.tableData2 = res.data.list
            this.loading = false
          }
        })
      },
      //重置查询选项
      resetSolvedTask: function () {
        this.filters = {
          keywords: ''
        };
        this.$forceUpdate();  // 强制更新
        this.findSolvedTask(null);
      },

      handleClick: function (tab) {
        this.filters = {
          keywords: ""
        }
        if (tab.name === 'solvedTask') {
          this.findSolvedTask();
        } else {
          this.findMyTask();
        }
      },

      // 批量删除
      handleDelete: function (row) {
        this.$confirm('确认删除选中记录吗？', '提示', {
          type: 'warning'
        }).then(() => {
          var ids = {"ids": row.id};
          this.$api.sysTaskDeal.batchDelete(ids).then(
            res => {
              this.findMyTask();
              if (res.code === 200) {
                this.$message({message: '操作成功', type: 'success'})
                this.dialogVisible = false
                this.$refs['dataForm'].resetFields()
              } else {
                this.$message({message: '操作失败, ' + res.msg, type: 'error'})
              }
            })
        })
      },
      // 查看界面
      handleView: function (row) {
        this.$router.push({path:row.viewUrl,query:{referId:row.referId,taskDealId:row.id,method:'view'}});
      },
      // 处理界面
      handleEdit: function (row) {
        this.$router.push({path:row.viewUrl,query:{referId:row.referId,taskDealId:row.id,method:'edit'}});
      },
      // 时间格式化
      dateFormat: function (row, column, cellValue, index) {
        return format(row[column.property])
      },
      // 处理表格列过滤显示
      initColumns: function () {
        this.columns = [
          {prop: "type", label: "任务类型", minWidth: 100},
          {prop: "title", label: "任务标题", minWidth: 100},
          {prop: "createTime", label: "创建时间", minWidth: 100},
          {prop: "createUser", label: "创建人", minWidth: 100},
          {prop: "status", label: "状态", minWidth: 100}
        ];
        this.filterColumns = JSON.parse(JSON.stringify(this.columns));
      }
    },
    mounted() {
      this.findMyTask()
    }
  }
</script>

<style scoped>
.list_div /deep/ .el-tabs__header {
  margin-top: 10px;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Sys/SysTaskDeal.vue